<div class="row" *ngIf="pendingLoading || pendingRegistrations.length > 0">
  <div class="col-12">
    <div class="card mt-3 pending-registration-card">
      <div class="card-header pending-registration-header">
        <div>
          <div class="d-flex align-items-center">
            <h5 class="fs-0 mb-0">Pending registrations</h5>
            <span class="pending-registration-count ml-2">{{pendingRegistrations.length}}</span>
          </div>
          <div class="pending-registration-subtitle">Review the submitted details and approve access.</div>
        </div>
      </div>

      <div class="pending-registration-loading" *ngIf="pendingLoading && pendingRegistrations.length === 0">
        Loading registration requests...
      </div>

      <div class="table-responsive" *ngIf="pendingRegistrations.length > 0">
        <table class="table table-sm mb-0 pending-registration-table">
          <thead class="slb-header">
            <tr>
              <th>Applicant</th>
              <th>Segments</th>
              <th>Requested</th>
              <th class="text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let registration of pendingRegistrations">
              <td>
                <strong>{{registration.name}}</strong>
                <div class="pending-registration-meta">{{registration.email}}</div>
              </td>
              <td>
                <span>{{registration.segment || 'Not assigned'}}</span>
                <div class="pending-registration-meta" *ngIf="registration.subSegment || registration.ssubSegment">
                  {{registration.subSegment || '-'}} / {{registration.ssubSegment || '-'}}
                </div>
              </td>
              <td class="white-space-nowrap">
                {{registration.requestDate | date:'dd/MM/yyyy HH:mm'}}
              </td>
              <td>
                <div class="pending-registration-actions">
                  <button class="btn btn-success btn-sm" type="button"
                          (click)="approvePendingRegistration(registration)"
                          [disabled]="approvingRegistrationId !== 0"
                          title="Approve and activate this account">
                    <span class="fas" [ngClass]="approvingRegistrationId === registration.id ? 'fa-spinner fa-spin' : 'fa-check'"></span>
                    <span class="ml-1">Approve</span>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <div class="card mt-3">
      <div class="card-header">
        <div class="row align-items-center justify-content-between">
          <div class="col-6 col-sm-auto d-flex align-items-center pr-0">
            <h5 class="fs-0 mb-0 text-nowrap py-2 py-xl-0">Users list</h5>
          </div>
          <div class="col-6 col-sm-auto ml-auto text-right pl-0">
            <div id="divSearchFilterU" class="d-inline-block position-relative mr-2">
              <input type="search" id="inputSearchFilter" class="form-control form-control-sm" [(ngModel)]="searchU"
                     (input)="getSearchDataU(searchU)"
                     placeholder="Search..." autocomplete="off" appTrimLeft />
            </div>

            <button class="btn btn-sm btn-danger" (click)="modalDelete(0,'','',['userStatus'])" [hidden]="_pluginservice.checkedList?.length==0">
              <span class="fas fa-trash-alt d-inline-block d-sm-none"
                    data-fa-transform="shrink-3 down-2"></span>
              <span class="d-none d-sm-inline-block">
                Delete
              </span>
            </button>
            <button class="btn btn-success btn-sm" [hidden]="_pluginservice.checkedList?.length!=0"
                    data-toggle="modal" type="button" (click)="editUser(0)">
              <span class="fas fa-plus d-inline-block d-sm-none"
                    data-fa-transform="shrink-3 down-2"></span>
              <span class="d-none d-sm-inline-block">
                Create new
              </span>
            </button>
          </div>
        </div>
      </div>
      <div [style.opacity]="loading ? '0' : '1'">
        <div class="card-body p-0 card-scroll" (scroll)="onScrollData($event)">
          <div class="falcon-data-table">
            <div class="falcon-data-table table-responsive">
              <table class="table table-sm mb-0 table-striped border-bottom">
                <thead class="slb-header sticky-header">
                  <tr>
                    <th class="pr-1 align-middle w-30px">
                      <div class="custom-control custom-checkbox">
                        <input class="custom-control-input checkbox-bulk-select" id="userBulk" type="checkbox"
                               [(ngModel)]="_pluginservice.masterSelected"
                               (change)="_pluginservice.checkAll(userData,'userBulk')"
                               [disabled]="userData?.length==0"
                               [attr.checked]="_pluginservice.checkedList.length==userData?.length ? 'checked' : null"
                               [attr.indeterminate]="(_pluginservice.checkedList.length>0) && _pluginservice.checkedList.length!=userData?.length ? 'indeterminate' : false"
                               [indeterminate]="(_pluginservice.checkedList.length>0) && _pluginservice.checkedList.length!=userData?.length ? 'indeterminate' : false">
                        <label class="custom-control-label" for="userBulk"></label>
                      </div>
                    </th>
                    <th class="pr-1 align-middle cursor-pointer" (click)="sortType = 'name'; sortReverse = !sortReverse;sortData('name');">
                      Name
                      <span *ngIf="sortType == 'name' && sortReverse">
                        <i class="fas fa-sort-up"></i>
                      </span>
                      <span *ngIf="sortType == 'name' && !sortReverse">
                        <i class="fas fa-sort-down"></i>
                      </span>
                    </th>
                    <th class="pr-1 align-middle cursor-pointer" (click)="sortType = 'role'; sortReverse = !sortReverse;sortData('role');">
                      Role
                      <span *ngIf="sortType == 'role' && sortReverse">
                        <i class="fas fa-sort-up"></i>
                      </span>
                      <span *ngIf="sortType == 'role' && !sortReverse">
                        <i class="fas fa-sort-down"></i>
                      </span>
                    </th>
                    <th class="pr-1 align-middle cursor-pointer" (click)="sortType = 'segment'; sortReverse = !sortReverse;sortData('segment');">
                      Segment
                      <span *ngIf="sortType == 'segment' && sortReverse">
                        <i class="fas fa-sort-up"></i>
                      </span>
                      <span *ngIf="sortType == 'segment' && !sortReverse">
                        <i class="fas fa-sort-down"></i>
                      </span>
                    </th>
                    <th class="pr-1 align-middle cursor-pointer" (click)="sortType = 'email'; sortReverse = !sortReverse;sortData('email');">
                      Email
                      <span *ngIf="sortType == 'email' && sortReverse">
                        <i class="fas fa-sort-up"></i>
                      </span>
                      <span *ngIf="sortType == 'email' && !sortReverse">
                        <i class="fas fa-sort-down"></i>
                      </span>
                    </th>
                    <th class="pr-1 align-middle cursor-pointer" (click)="sortType = 'manager'; sortReverse = !sortReverse;sortData('manager');">
                      Manager
                      <span *ngIf="sortType == 'manager' && sortReverse">
                        <i class="fas fa-sort-up"></i>
                      </span>
                      <span *ngIf="sortType == 'manager' && !sortReverse">
                        <i class="fas fa-sort-down"></i>
                      </span>
                    </th>
                    <th class="pr-1 align-middle">
                      Is Approver?
                    </th>
                    <th class="pr-1 align-middle cursor-pointer" (click)="sortType = 'status'; sortReverse = !sortReverse;sortData('status');">
                      Status
                      <span *ngIf="sortType == 'status' && sortReverse">
                        <i class="fas fa-sort-up"></i>
                      </span>
                      <span *ngIf="sortType == 'status' && !sortReverse">
                        <i class="fas fa-sort-down"></i>
                      </span>
                    </th>
                    <th class="pr-1 align-middle">
                    </th>
                  </tr>
                </thead>
                <tbody id="userTbody">
                  <tr class="btn-reveal-trigger" *ngFor="let u of userData">
                    <td class="align-middle">
                      <div class="custom-control custom-checkbox">
                        <input class="custom-control-input checkbox-bulk-select-target" type="checkbox" id="u{{u.id}}"
                               [(ngModel)]="u.checkboxOpe"
                               (change)="_pluginservice.isAllSelected(userData);getCheckedId(u.id)" />
                        <label class="custom-control-label" for="u{{u.id}}"></label>
                      </div>
                    </td>
                    <th class="align-middle">
                      <a href="javascript:void(0)" (click)="editUser(u.id)">
                        {{u.name}}
                      </a>
                    </th>
                    <td class="align-middle">
                      {{u.role}}
                    </td>
                    <td class="align-middle">
                      {{u.segment}}
                    </td>
                    <td class="align-middle">
                      {{u.email}}
                    </td>
                    <td class="align-middle">
                      {{u.manager}}
                    </td>
                    <td class="align-middle">
                      <span *ngIf="u.isApprover" class="badge badge-pill badge-soft-success px-3 py-2">Approver</span>
                    </td>
                    <td class="align-middle">
                      <div class="custom-control custom-switch">
                        <input class="custom-control-input" type="checkbox" id="switch{{u.id}}" [(ngModel)]="u.status" (change)="changeStatus('user', u.id, u.status,'changeStatus')" />
                        <label class="custom-control-label cursor-pointer" for="switch{{u.id}}"></label>
                      </div>
                    </td>
                    <td class="align-middle white-space-nowrap">
                      <div class="dropdown text-sans-serif" id="threeNo{{u.id}}">
                        <button class="btn btn-link text-600 btn-sm dropdown-toggle btn-reveal mr-3"
                                type="button" id="dropdown0"
                                data-toggle="dropdown"
                                data-boundary="html"
                                aria-haspopup="true"
                                aria-expanded="false">
                          <span class="fas fa-ellipsis-h fs--1"></span>
                        </button>
                        <div class="dropdown-menu dropdown-menu-right border py-0"
                             aria-labelledby="dropdown0">
                          <div class="bg-white py-2">
                            <a class="dropdown-item cursor-pointer" href="javascript:void(0)" (click)="editUser(u.id)">Edit</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item text-danger" href="javascript:void(0)" (click)="modalDelete(u.id,'user','deleteUser',[])">Delete</a>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody class="text-center w-100 py-3 bg-light" *ngIf="(userData | filter: searchU).length === 0">
                  <tr>
                    <td colspan="8" class="px-2 py-3 bg-light text-center w-100">
                      <p class="text-center bold-text font-size18px m-0">No data available</p>
                      <p class="text-center m-0 text-gray font-size13px">There is nothing to show you right now</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <ngx-loading [show]="loading" class="z-index1000"></ngx-loading>
    </div>
  </div>
</div>
<!--Modal User-->
<div class="modal fade px-0" style="padding-left:0!important;padding-right:0!important" id="userModal" tabindex="-1" role="dialog" aria-labelledby="userModal" data-backdrop="static" data-keyboard="false"
     aria-hidden="true" (keydown.esc)="modalUserClose()">
  <div class="modal-dialog activity-select-modal-width" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">
          <span>{{modalTitle}}</span>
        </h5>
        <button class="close" type="button" aria-label="Close" (click)="modalUserClose()">
          <span class="font-weight-light" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body modal-padding">
        <div class="row">
          <div class="col-md-6 col-12">
            <div class="form-group">
              <label for="name">First name <span class="text-danger">*</span></label>
              <input class="form-control form-control-sm" id="name" type="text" [(ngModel)]="userObj.name" required appTrimLeft autocomplete="off" />
            </div>
          </div>
          <div class="col-md-6 col-12">
            <div class="form-group">
              <label for="lastName">Last name <span class="text-danger">*</span></label>
              <input class="form-control  form-control-sm" id="lastName" type="text" [(ngModel)]="userObj.lastName" required appTrimLeft autocomplete="off" />
            </div>
          </div>

          <div class="col-md-6 col-12">
            <div class="form-group">
              <label for="userType">Role <span class="text-danger">*</span></label>
              <select class="form-control  form-control-sm" id="userType" name="userType" [(ngModel)]="userObj.userType" required>
                <option [ngValue]="0">Choose</option>
                <option [ngValue]="ur.id" *ngFor="let ur of userObj.userRoles">{{ur.name}}</option>
              </select>
            </div>
          </div>
          <div class="col-md-6 col-12">
            <div class="form-group">
              <label for="userType">Manager <span class="text-danger">*</span></label>
              <select class="form-control  form-control-sm" id="manager" name="manager" [(ngModel)]="userObj.managerId" required>
                <option [ngValue]="0">Choose</option>
                <option [ngValue]="m.id" *ngFor="let m of userObj.managerObj">{{m.name}}</option>
              </select>
            </div>
          </div>

          <div class="col-md-6 col-12">
            <div class="form-group">
              <label for="userType">Segment Level 1 <span class="text-danger">*</span></label>
              <select class="form-control  form-control-sm" id="segment" name="segment" [(ngModel)]="userObj.segmentId" (change)="segmentChange(userObj.segmentId)" required>
                <option [ngValue]="0">Choose</option>
                <option [ngValue]="s.id" *ngFor="let s of userObj.segmentObj">{{s.name}}</option>
              </select>
            </div>
          </div>
          <div class="col-md-6 col-12">
            <div class="form-group">
              <label for="userType">Segment Level 2 <span class="text-danger">*</span></label>
              <select class="form-control  form-control-sm" id="subsegment" name="subsegment" [(ngModel)]="userObj.subSegmentId" (change)="subSegmentChange(userObj.subSegmentId)" required>
                <option [ngValue]="0">Choose</option>
                <option [ngValue]="ss.id" *ngFor="let ss of userObj.subSegmentObj">{{ss.name}}</option>
              </select>
            </div>
          </div>
          <div class="col-md-6 col-12">
            <div class="form-group">
              <label for="userType">Segment Level 3 <span class="text-danger">*</span></label>
              <select class="form-control  form-control-sm" id="ssubsegment" name="ssubsegment" [(ngModel)]="userObj.ssubSegmentId" required>
                <option [ngValue]="0">Choose</option>
                <option [ngValue]="sss.id" *ngFor="let sss of userObj.ssubSegmentObj">{{sss.name}}</option>
              </select>
            </div>
          </div>

          <div class="col-md-6 col-12 col-md-6 col-12 d-flex justify-content-left align-items-center">
            <span class="form-check mt-3">
              <input type="checkbox" class="form-check-input cursor-pointer" id="isApprover"
                     [(ngModel)]="userObj.isApprover">
              <label class="form-check-label label-completed" for="isApprover">Is Approver?</label>
            </span>
          </div>






          <div class="col-md-6 col-12">
            <div class="form-group">
              <label for="emailUser">Email <span class="text-danger">*</span></label>
              <input class="form-control  form-control-sm" id="emailUser" type="email" [(ngModel)]="userObj.email" email
                     appTrimLeft pattern="^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$" #emailUser="ngModel" required autocomplete="off" autofocus (keyup)="resetchkOpe()" />
              <div *ngIf="emailUser.invalid && (emailUser.dirty || emailUser.touched)" class="validation">
                Please input valid e-mail
              </div>
            </div>
          </div>
          <div class="col-md-6 col-12 text-left mt-2 col-md-6 col-12 d-flex justify-content-left align-items-center" *ngIf="modalType!=0">
            <span class="form-check mt-3">
              <input type="checkbox" class="form-check-input cursor-pointer" id="letChangePassword"
                     [(ngModel)]="changePasswordOpe" (change)="chagenPasswordPermission()">
              <label class="form-check-label label-completed" for="letChangePassword">Change Password</label>
            </span>
          </div>
          <div class="col-md-6 col-12" *ngIf="modalType==0 || changePasswordOpe">
            <div class="form-group">
              <label for="password">Password <span class="text-danger">*</span></label>
              <input class="form-control  form-control-sm" id="password" type="password" [(ngModel)]="userObj.password" required autocomplete="off" />
            </div>
          </div>
          <div class="col-md-6 col-12">
            <div class="form-group">
              <label for="image">Image</label>

              <input type="file"
                     (change)="fileChangeEvent($event)"
                     class="form-control form-control-sm"
                     id="image"
                     tabindex="5"
                     accept="image/*" />

              <div class="validation">{{errorImage}}</div>

              <div class="mt-2" *ngIf="imageSrc">
                <img [src]="imageSrc"
                     class="w-100px h-100px border rounded d-block mb-2" />

                <button type="button"
                        class="btn btn-danger btn-sm"
                        (click)="removeImage()">
                  Delete image
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-12" *ngIf="modalType==0 || changePasswordOpe">
            <div class="form-group">
              <label for="confirtmationPassword">Re-type Password <span class="text-danger">*</span></label>
              <input class="form-control  form-control-sm" id="confirtmationPassword" type="password" minlength="5" [(ngModel)]="userObj.confirmationPassword" required autocomplete="off" />
            </div>
          </div>








          <div class="col-12">
            <div *ngIf="userObj.password && userObj.password?.length<6" class="validation text-right">
              Password is required 6 characters minimum
            </div>
            <div *ngIf="userObj.password && userObj.confirmationPassword && userObj.password?.length>=6 && userObj.password!=userObj.confirmationPassword" class="validation text-right">
              Password and Confirmation Password must be match
            </div>
            <div *ngIf="chkOpe==1" class="validation bold-text text-right">
              This e-mail address is currently in use
            </div>
          </div>
          <div class="dis-button-group position-absolute" *ngIf="modalType!=0 || userLimit!=userData.length">
            <button class="btn btn-falcon-default btn-sm mr-2" type="button" (click)="modalUserClose()">Close</button>
            <button class="btn btn-primary btn-sm" id="btnUser" type="button"
                    [disabled]="!userObj.name || !userObj.lastName || userObj.segmentId==0 || userObj.subSegmentId==0 || userObj.userType==0 || (!userObj.email || (emailUser.invalid && (emailUser.dirty || emailUser.touched))) || disableButton==1 || (changePasswordOpe && (userObj.password?.length<6 || !userObj.password || !userObj.confirmationPassword || userObj.password!=userObj.confirmationPassword))" (click)="checkUserEmail()">
              Save
            </button>
          </div>
        </div>
      </div>
      <div class="modal-footer" *ngIf="modalType!=0 || userLimit!=userData.length">
        <button class="btn btn-primary btn-sm invisible">Save</button>
      </div>
    </div>
  </div>
</div>
<!-- Modal Delete-->
<div class="modal fade z-index10001 pr-0" style="padding-right:0!important" id="modalDelete" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
     data-backdrop="static" data-keyboard="false" aria-hidden="true" (keydown.esc)="modalDeleteClose()">
  <div class="modal-dialog modal-dialog-center modal-delete-width" role="document">
    <div class="modal-content">
      <div class="modal-header" style="border-bottom: none">
        <div class="modal-delete-header-icondiv">
          <i class="far fa-times-circle text-center modal-delete-circle-icon"></i>
        </div>
        <button class="close" type="button" data-dismiss="modal" aria-label="Close"
                (click)="modalDeleteClose()">
          <span class="font-weight-light" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p class="text-center fs-20 fw-600">Are you sure?</p>
        <p class="text-muted fs-13 pl-3 pr-3 text-center">Do you really want to delete {{delCount==1 ? 'this record' : 'these records'}}? This process can not be undone.</p>
      </div>
      <div class="modal-delete-footer">
        <button class="btn btn-sm mr-2 modal-delete-footer-cancel" type="button" data-dismiss="modal" (click)="modalDeleteClose()">Cancel</button>
        <button class="btn btn-danger btn-sm" type="button" (click)="deleteItem(delId,delType,delType2,delBulkArray)">Delete</button>
      </div>
    </div>
  </div>
</div>
<!-- Modal Image-->
<div class="modal fade mt-5" id="modal_file" tabindex="-1" role="dialog" aria-labelledby="modal_customer" data-backdrop="static" data-keyboard="false"
     aria-hidden="true">
  <div class="modal-dialog max-width-40per" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Image</h5>
        <button class="close" type="button" data-dismiss="modal" aria-label="Close">
          <span class="font-weight-light" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <image-cropper [imageChangedEvent]="imageChangedEvent"
                       [maintainAspectRatio]="true"
                       [aspectRatio]="8 / 8"
                       format="png"
                       [resizeToWidth]="80"
                       [resizeToHeight]="80"
                       (imageCropped)="imageCropped($event)"></image-cropper>
        <img [src]="croppedImage" class="w-100px h-100px" />
      </div>
      <div class="modal-footer">
        <button class="btn btn-falcon-default btn-sm" type="button" data-dismiss="modal">Close</button>
        <button class="btn btn-primary btn-sm" type="button" (click)="SelectImage()"> <div class="g_spinner" *ngIf="spinner"></div> Select</button>
      </div>
    </div>
  </div>
</div>

